import { Link } from '@belong/ui';
import { PrismicDocument } from '@prismicio/types';
import { BlogCarousel } from 'src/features/homeowners/components/blog-carousel/blog-carousel';
import { HOMEOWNERS_STRINGS } from 'src/features/homeowners/homeowners.strings';

type Props = {
  blogPosts: PrismicDocument[];
};

export const BlogCarouselSlice = ({ blogPosts }: Props) => {
  return (
    <div className="container">
      <div className="carousel-container flex flex-col items-center">
        <div className="mb-lg md:mb-xl w-full">
          <BlogCarousel blogPosts={blogPosts} />
        </div>
        <Link
          href="/blog"
          variant="outline"
          buttonType="secondary"
          size="large"
        >
          {HOMEOWNERS_STRINGS['blogSection.ctaLabel']}
        </Link>
      </div>
    </div>
  );
};
